import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import InitiativeDetailContainer from '../../containers/initiatives/InitiativeDetailContainer.jsx';

const ShowInitiative = ({
  initiativeId,
  initiativeType,
  stakeholderParticipationId,
  initiativeParticipationId,
  participantsCsv,
  stakeholdersCsv,
  slug,
}) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('initiative')} | ChangeSync</title>
    </Helmet>
    <InitiativeDetailContainer
      isPreview
      slug={slug}
      initiativeId={initiativeId}
      initiativeType={initiativeType}
      initiativeParticipationId={initiativeParticipationId}
      stakeholderParticipationId={stakeholderParticipationId}
      stakeholdersCsv={stakeholdersCsv}
      participantsCsv={participantsCsv}
    />
  </>
);

ShowInitiative.getInitialProps = ({ query }) => ({
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  initiativeParticipationId: query.participant
    ? Number(query.participant)
    : null,
  stakeholderParticipationId: query.stakeholder
    ? Number(query.stakeholder)
    : null,
  participantsCsv: query.participantsCsv,
  stakeholdersCsv: query.stakeholdersCsv,
  slug: query.slug,
});

export default requireAuth(withRouterParams(ShowInitiative));
